import { SupportCasesItem } from '../../../types';
import { Text } from '../../Atoms/Text';
import { Link } from 'react-router-dom';
import { getMetaData } from '../DetailsDrawer/detailsDrawersHelpers';
import { AttachmentCTA } from '../AttachmentCTA';

export interface CaseCreatedFormProps {
  addAttachments: (files: File[]) => void;
  data: SupportCasesItem;
  headerCopy: string;
  bodyCopy: string;
  ctaCopy: string;
  link?: {
    title: string;
    to: string;
  };
}

export const CaseCreatedForm = ({
  addAttachments,
  data,
  headerCopy,
  bodyCopy,
  ctaCopy,
  link
}: CaseCreatedFormProps) => {
  return (
    <>
      <Text
        className="text-[22px] py-2"
        color="grey9"
        weight="medium">
        {headerCopy}
      </Text>
      <Text
        className="py-2"
        color="grey5">
        {bodyCopy}
      </Text>
      {link && (
        <Link
          state={{
            data,
            ...getMetaData('support')
          }}
          className="ml-auto"
          title={link.title}
          to={link.to}>
          <Text
            className="py-2 text-[13px]"
            color="indigo">
            {ctaCopy}
          </Text>
        </Link>
      )}
      {!link && <AttachmentCTA addAttachments={addAttachments} />}
    </>
  );
};
